import { useMutation } from '@tanstack/react-query';

import { PostForgotPasswordPayload, PostForgotPasswordResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';

export const postForgotPassword = (payload: PostForgotPasswordPayload): Promise<PostForgotPasswordResponse> => {
    return axios.post('/forgot-password', payload);
};

type UsePostForgotPasswordOptions = {
    config?: MutationConfig<typeof postForgotPassword>;
    data?: PostForgotPasswordPayload;
};

export const usePostForgotPassword = ({ config }: UsePostForgotPasswordOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postForgotPassword,
    });
};
